export default __webpack_public_path__ + "static/media/trr-drink-wine-white.de154492.png";